import React from 'react'
import { css } from 'aphrodite'
import { Container, Row, Col } from 'reactstrap'

import style from '../style'

export const ReviewsSection = props => {
  return (
    <Container>
      <header>
        <h2 className={css(style.reviews.h2)}>There's Simply Nothing Better</h2>
        <blockquote className={css(style.reviews.blockquote)}>
          <i className={`d-block`}>
            I've been using VPPGN to generate income for my community servers
            and I've pretty much let them run on autopilot. I've also been able
            to create a lasting and trusting relationship with those in the
            company, and I can't say I've ever once thought about going with
            anyone else. I'm a member for life.
          </i>
          <cite className={css(style.reviews.name)}>
            <span>Jim</span>, NRG
          </cite>
          <div className={css(style.reviews.divider)} />
        </blockquote>
      </header>
      <Row>
        <Col xs='12' md='4'>
          <RenderReviewBox
            name={`Patryk`}
            company={`AlliedGamers`}
            text={`I've been beta testing VPPGN from the beginning, and I have to say I'm really happy being their client; you're not limited with requests based on CTR unlike with other networks.`}
          />
        </Col>
        <Col xs='12' md='4'>
          <RenderReviewBox
            name={`Swoobles`}
            company={`Gaming Community`}
            text={`I decided to give them a try with my Swoobles servers since they are a new player in the MOTD advertising industry and I'm very happy so far.`}
          />
        </Col>
        <Col xs='12' md='4'>
          <RenderReviewBox
            name={`Marcos`}
            company={`AlliedGamers`}
            text={`I am very happy with what I've been rewareded with. Definitely a company to consider when advertising in-game!`}
          />
        </Col>
      </Row>
    </Container>
  )
}

const RenderReviewBox = props => {
  return (
    <div className={css(style.reviews.box)}>
      <p className={css(style.reviews.boxParagraph)}>{props.text}</p>
      <cite className={css(style.reviews.boxName)}>
        <span className={css(style.reviews.boxNameStrong)}>{props.name}</span>,{' '}
        {props.company}
      </cite>
    </div>
  )
}

export default ReviewsSection



// WEBPACK FOOTER //
// ./src/components/Home/partials/reviews.js